if (!window.__cartCouponBound) {
  window.__cartCouponBound = true;

  const root = window.Shopify?.routes?.root || '/';
  const sectionIds = ['cart-drawer', 'cart-icon-bubble', 'main-cart-footer'];

  function setFormLoading(form, isLoading) {
    const submitButton = form.querySelector('[type="submit"]');
    if (!submitButton) return;

    submitButton.disabled = isLoading;
    submitButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  function replaceElementFromHTML(selector, html) {
    const currentElement = document.querySelector(selector);
    if (!currentElement || !html) return;

    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const nextElement = parsedHTML.querySelector(selector);
    if (!nextElement) return;

    currentElement.replaceWith(nextElement);
  }

  function replaceElementContentFromHTML(selector, html) {
    const currentElement = document.querySelector(selector);
    if (!currentElement || !html) return;

    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const nextElement = parsedHTML.querySelector(selector);
    if (!nextElement) return;

    currentElement.innerHTML = nextElement.innerHTML;
  }

  function refreshCartSections() {
    const sectionsUrl = `${root}cart?sections=${sectionIds.join(',')}`;

    return fetch(sectionsUrl, { credentials: 'same-origin' })
      .then((response) => response.json())
      .then((sections) => {
        replaceElementFromHTML('cart-drawer', sections['cart-drawer']);
        replaceElementContentFromHTML('#cart-icon-bubble', sections['cart-icon-bubble']);
        replaceElementFromHTML('#main-cart-footer', sections['main-cart-footer']);

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      });
  }

  document.addEventListener('submit', function (event) {
    const form = event.target.closest('[data-cart-coupon-form]');
    if (!form) return;

    event.preventDefault();

    const input = form.querySelector('input[name="coupon"]');
    const code = input && input.value.trim();
    if (!code) return;

    setFormLoading(form, true);

    fetch(`${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(`${root}cart`)}`, {
      credentials: 'same-origin',
    })
      .then(() => refreshCartSections())
      .catch((error) => {
        console.error('Could not apply cart coupon', error);
      })
      .finally(() => {
        setFormLoading(form, false);
      });
  });
}
